var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "block_container"
  }, [_vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "header blc_row"
  }, [_c('span', {
    staticClass: "block_number"
  }, [_vm._v("Block")]), _c('span', {
    staticClass: "block_age"
  }, [_vm._v("Age")]), _c('span', {
    staticClass: "block_transactions"
  }, [_vm._v("Txn")]), _c('span', {
    staticClass: "block_hash"
  }, [_vm._v("Hash")]), _c('span', {
    staticClass: "block_gas_used"
  }, [_vm._v("Gas Used")]), _c('span', {
    staticClass: "block_gas_limit"
  }, [_vm._v("Gas Limit")]), _c('span', {
    staticClass: "block_burned"
  }, [_vm._v("Size (bytes)")])]) : _c('div', {
    staticClass: "header blc_row"
  }, [_c('span', {
    staticClass: "block_number"
  }, [_vm._v("Block")]), _c('span', {
    staticClass: "block_age"
  }, [_vm._v("Age")]), _c('span', {
    staticClass: "block_transactions"
  }, [_vm._v("Txn")])]), _vm.blocks ? [!_vm.isLoading ? _c('ul', {
    staticClass: "list"
  }, _vm._l(_vm.blocks, function (block) {
    return _c('li', {
      key: block.blockNumber || block.header.number,
      staticClass: "blc_row"
    }, [_c('span', {
      staticClass: "block_number"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.hasSubnet ? {
          path: "/evmblock/".concat(block.blockNumber || block.header.number),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.subnetName
          }
        } : {
          path: "/evmblock/".concat(block.blockNumber || block.header.number),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME
          }
        }
      }
    }, [_vm._v(" " + _vm._s(block.blockNumber || block.header.number) + " ")])], 1), _c('span', {
      staticClass: "block_age"
    }, [_vm._v(_vm._s(_vm._f("fromNow")(parseInt(block.header.timestamp))))]), _c('span', {
      staticClass: "block_transactions"
    }, [_vm._v(_vm._s(block.transactions.length))]), _vm.$vuetify.breakpoint.mdAndUp ? _c('span', {
      staticClass: "block_hash"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": _vm.hasSubnet ? {
          path: "/evmblock/".concat(block.header.hash),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.subnetName
          }
        } : {
          path: "/evmblock/".concat(block.header.hash),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME
          }
        }
      }
    }, [_vm._v(" " + _vm._s(block.header.hash) + " ")])], 1), _c('CopyText', {
      attrs: {
        "value": block.header.hash
      }
    })], 1) : _vm._e(), _vm.$vuetify.breakpoint.mdAndUp ? _c('span', {
      staticClass: "block_gas_used"
    }, [_vm._v(_vm._s(block.header.gasUsed))]) : _vm._e(), _vm.$vuetify.breakpoint.mdAndUp ? _c('span', {
      staticClass: "block_gas_limit"
    }, [_vm._v(_vm._s(parseInt(block.header.gasLimit).toLocaleString('en-US')))]) : _vm._e(), _vm.$vuetify.breakpoint.mdAndUp ? _c('span', {
      staticClass: "block_burned"
    }, [_vm._v(_vm._s(parseInt(block.header.size)))]) : _vm._e()]);
  }), 0) : _c('Loader', {
    attrs: {
      "message": "Fetching blocks",
      "content-id": ""
    }
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }